import {
  Addons,
  BusinessPlanOptions,
  FamilyPlanOptions,
  familyPlans,
  businessPlans,
} from "@ecologi/shared";
import { formatAPIErrorForView } from "../../lib";

export const selectErrorMessageFromResult = (result) => {
  return result.error ? formatAPIErrorForView(result.error) : undefined;
};

export const selectPaymentErrorMessage = (
  errorCode?: string,
  errorMessage?: string
) => {
  switch (errorCode) {
    case "invalid_zip_code":
      return "It looks like your post code is incorrect. Please check it and try again.";

    case "billing_address[zip]":
      return "It looks like your post code is incorrect. Please check it and try again.";

    case "incorrect_cvc":
      return "It looks like your CVC security code is incorrect. Please check it and try again.";

    case "incomplete_cvc":
      return "It looks like your CVC security code is incomplete. Please check it and try again.";

    case "card_declined":
      return "Your card was declined. Please make sure you have sufficient funds and try again.";

    case "expired_card":
      return "You’re card seems to have expired. Please use a different card and try again.";

    case "invalid_expiry_month_past":
      return "You’re card seems to have expired. Please use a different card and try again.";

    case "processing_error":
      return "An error occurred while processing your card. Try again in a little bit.";

    case "add_card_error":
      if (errorMessage) {
        const textFromStripe = errorMessage.split(":").pop();
        if (textFromStripe) {
          if (textFromStripe.includes("Try again")) {
            return textFromStripe;
          }
          return `${textFromStripe} Please double check your details and try again.`;
        }
      }
      return "Your card was declined. Please double check your details and try again.";

    case "payment_processing_failed":
      return "We failed to process your payment. This is likely due to your bank requiring further verification which we cannot provide at this time. Please try a different card. We’re sorry for any inconvenience caused.";

    case "referenced_resource_not_found":
      return "The coupon code you used is not valid. Please check it and try again.";

    default:
      //   logger(errorCode, errorMessage);
      return "We’re not sure what happened, sorry! Please try again. If the error persists please try refreshing the page or contacting hq@ecologi.com for assistance.";
  }
};

interface Addon {
  id: string;
  quantity: number;
}

export interface ProjectAddon {
  id: string;
  projectId: number;
  price: number;
  countryNiceCopy: string;
  countryNiceCopyShort: string;
  country: string;
  link: string;
}

export const selectSubscriptionAddons = (
  planId: string,
  addons: Addons,
  localProject: ProjectAddon | null,
  selectedPlanAddons?: FamilyPlanOptions | BusinessPlanOptions,
  numLocalTrees?: number
) => {
  const isFamilyPlan = familyPlans.includes(planId);
  const isBusinessPlan = businessPlans.includes(planId);

  let subscriptionAddons = [] as Addon[];

  if (selectedPlanAddons) {
    if (isFamilyPlan) {
      subscriptionAddons = [
        {
          id: addons.adults.id,
          quantity: (selectedPlanAddons as FamilyPlanOptions).adults,
        },
        {
          id: addons.children.id,
          quantity: (selectedPlanAddons as FamilyPlanOptions).children,
        },
        {
          id: addons.pets.id,
          quantity: (selectedPlanAddons as FamilyPlanOptions).pets,
        },
      ];
    } else if (isBusinessPlan) {
      subscriptionAddons = [
        {
          id: addons.tier1.id,
          quantity: (selectedPlanAddons as BusinessPlanOptions).tier1,
        },
        {
          id: addons.tier2.id,
          quantity: (selectedPlanAddons as BusinessPlanOptions).tier2,
        },
        {
          id: addons.tier3.id,
          quantity: (selectedPlanAddons as BusinessPlanOptions).tier3,
        },
      ];
    }
  }

  if (localProject && numLocalTrees) {
    subscriptionAddons.push({
      id: localProject.id,
      quantity: numLocalTrees,
    });
  }

  return subscriptionAddons.filter((addon) => addon.quantity > 0);
};
